// Interface

import util from '@/utils/classToObject'
import { IPositionRemarquableState } from './state'
import { AloPositionRemarquable } from '@/models/alo/AloPositionRemarquable'

export class PositionRemarquableGetter {  
      
  public positionRemarquables(state:IPositionRemarquableState,getters:any) {
    return state.positionRemarquables
  }

  public positionRemarquablesById(state:IPositionRemarquableState) {
    return state.positionRemarquables.reduce(
      (acc, positionRemarquable) => {
        acc[positionRemarquable.prmId!] = positionRemarquable
        return acc
      },
      {} as { [id: number]: AloPositionRemarquable }
    )
  }  

  public modifiedAdmPositionRemarquable(state:IPositionRemarquableState,getters:any) {
    return state.modifiedAdmPositionRemarquable
  }

  public originalAdmPositionRemarquable(state:IPositionRemarquableState,getters:any) {
    return state.originalAdmPositionRemarquable
  }

  public positionRemarquableLoading(state:IPositionRemarquableState,getters:any) {
    return state.positionRemarquableLoading
  }

  public positionRemarquableStatus(state:IPositionRemarquableState) {     
    return state.status
  }

  public adminPositionRemarquableFilter(state:IPositionRemarquableState) {     
    return state.adminFilter
  }
  
}

export default util.classToObject(PositionRemarquableGetter)